import { IAnalyticSdr } from '../../../types/analyticsSdr';

/**
 * Analytics SDR for Identity Event Logs Domain.
 * This information should match the values in the SDR Excel file referenced here:
 * https://chalk.charter.com/display/ERSPM/FE+Analytics
 */

const siteSection = 'Activity Logs';

export const idEventLogsAnalytics: IAnalyticSdr = {
  identityEventLogs: {
    siteSection,
    buttonClicks: {
      filterCancelBtn: {
        itemClicked: 'Cancel',
      },
      filterViewResultsBtn: {
        itemClicked: 'View Results',
      },
      filterClearFiltersBtn: {
        itemClicked: 'Clear Filters',
      },
      closeFilterDrawerBtn: {
        itemClicked: 'Close Filter Drawer',
      },
    },
    menuSelections: {
      dateMenu: {
        itemClicked: 'Date',
      },
      organizationsMenu: {
        itemClicked: 'Organizations',
      },
      editorsMenu: {
        itemClicked: 'Editors',
      },
      typesMenu: {
        itemClicked: 'Types',
      },
      statusMenu: {
        itemClicked: 'Status',
      },
      eventNameMenu: {
        itemClicked: 'Event Name',
      },
    },
  },
};
